var render = function render(){var _vm=this,_c=_vm._self._c;return _c('table',{staticClass:"m-information-table"},_vm._l((_vm.information),function(info){return _c('tr',[_c('th',{staticClass:"m-information-table__head"},[_vm._v(_vm._s(info.head))]),_c('td',{staticClass:"m-information-table__description"},[_vm._v(_vm._s(info.description))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }